<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm logo-md">
              <!-- <img src="@/assets/images/logo.svg" alt height="22" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                alt
                style="max-height: 50px"
              />
            </span>
            <span class="logo-lg">
              <!-- <img src="@/assets/images/logo-dark.png" alt height="17" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                alt
                style="max-height: 50px"
              />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm logo-md">
              <!-- <img src="@/assets/images/logo-light.svg" alt height="22" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                alt
                style="max-height: 50px"
              />
            </span>
            <span class="logo-lg">
              <!-- <img src="@/assets/images/logo-light.png" alt height="19" /> -->
              <img
                src="@/assets/images/mascot-logo.png"
                style="max-height: 50px"
              />
            </span>
          </router-link>
        </div>
      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>
        <div class="d-none d-lg-inline-block noti-icon mt-2">
          <b-button
            v-if="GET_APPLICATION_SELECTED.id"
            variant="light"
            @click="$bvModal.show('modal-scoped')"
          >
            <b-avatar :text="GET_APPLICATION_SELECTED.code" variant="info" />
            {{ GET_APPLICATION_SELECTED.name }}
          </b-button>
          <b-button v-else class="mt-2" @click="$bvModal.show('modal-scoped')">
            <i class="bx bx-customize"></i>
          </b-button>
        </div>
        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              v-if="userOAuth && userOAuth.photo"
              class="rounded-circle header-profile-user"
              :src="userOAuth.photo"
              alt="Header Avatar"
            />
            <i v-else class="bx bx-user h3 align-middle mr-1"></i>
            <span class="d-none d-xl-inline-block ml-1">{{
              userInfo.name_en
            }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
        </b-dropdown>

        <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-scoped"
      title="Select workspace application"
      hide-footer
      size="lg"
      hide-header-close
    >
      <template #default="{ ok }" v-if="applicationsDataModal">
        <div class="px-lg-2">
          <div class="row no-gutters">
            <input
                  type="text"
                  v-model="workspaceSearch"
                  class="form-control"
                  placeholder="Search Workspace"
                />
            <template v-for="(item, index) in filterWorkspace">
              <div class="col-sm-3" v-bind:key="index">
                <a
                  class="dropdown-icon-item"
                  href="javascript: void(0);"
                  @click="
                    onSetApplicationClick(item);
                    ok();
                  "
                >
                  <div class="row">
                    <div class="col-sm-12">
                      <b-avatar
                        class="avatar-center"
                        variant="primary"
                        :text="item.code"
                      ></b-avatar>
                    </div>
                  </div>
                  <span>{{ item.display_name }}</span>
                </a>
              </div>
            </template>
          </div>
        </div>
      </template>

      <!-- <template #modal-footer="{ ok, hide }">
        <b-button size="sm" variant="success" @click="ok()"> OK </b-button>
        <b-button size="sm" variant="outline-secondary" @click="hide('forget')">
          Forget it
        </b-button>
      </template> -->
    </b-modal>
  </header>
</template>

<script>

// import simplebar from "simplebar-vue";
import { getUserInfo } from "@/helpers/utils/jwt";
import applicationService from "@/helpers/service/application-provider";
import {
  layoutComputed,
  authComputed,
  applicationComputed,
  applicationMethods,
} from "@/state/helpers";

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...authComputed,
    ...applicationComputed,
    ...layoutComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken);
      } else return {};
    },
    userOAuth() {
      let user = this.$cookies.get(".oauth.usr");
      return user;
    },
  },
  components: {
    // simplebar,
  },
  data() {
    return {
      workspaceSearch:'',
      fullPage: true,
      applications: [],
      applicationsDataModal: [],
      filterWorkspace:[]
    };
  },
  mounted() {
    this.onFilter();
    if (!this.GET_APPLICATION_SELECTED.id) {
      this.$bvModal.show("modal-scoped");
    }
  },
  methods: {
    ...applicationMethods,
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    async onFilter() {
      this.showDataTable = true;
      let params = new URLSearchParams();
      params.append("pageSize", 9999);
      params.append("status", "Active");

      let result = await applicationService.getApplicationsAsync(params);
      if (result.status === 200) {
        this.applications = [];
        this.applicationsDataModal = result.data.items;
        this.filterWorkspace = this.applicationsDataModal
        var tmp = [];
        result.data.items.forEach((element, index) => {
          //   if (index !== 0 && index % 3 == 0) {
          //     this.applications.push({ items: tmp });
          tmp = [];
          tmp.push(element);
          //   } else {
          //     tmp.push(element);
          //     if (index + 1 === result.data.items.length) {
          this.applications.push({ items: tmp });
          //     }
          //   }
        });
        this.isLoading = false;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
      this.ADD_FILTER_APPLICATION(result.data.items);
    },
    onSetApplicationClick(item) {
      this.isLoading = true;
      this.ADD_APPLICATION_SELECTED({
        id: item.id,
        name: item.display_name,
        code: item.code,
      });
      setTimeout(() => {
        this.$router.go();
      }, 500);
    },
  },
  watch: {
    workspaceSearch(newVal){
      console.log('newVal',newVal,this.applicationsDataModal);
      if(newVal === '') this.filterWorkspace = this.applicationsDataModal
      const test = this.applicationsDataModal.filter((a)=>a.display_name.toLowerCase().includes(newVal.toLowerCase()))
      console.log('test',test);
      this.filterWorkspace = test
    },
    
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>
<style scoped>
.avatar-center {
  text-align: center;
  display: inline-flex;
}

</style>
